import { config } from "../../config";

export const clearEmptyValues = <T>(query: Record<string, T> | { [key: string]: T }) =>
  Object.keys(query).reduce(
    (prev, curr) => {
      if (curr && query[curr]) {
        return {
          ...prev,
          [curr]: query[curr],
        };
      }

      return prev as any;
    },
    {} as Record<string, string>
  );

type Config = typeof config;

const pathQueryHelper =
  (configUrl?: Config[keyof Config]) =>
  (path: string, organizationIdOrQuery?: number | Record<string, string>) => {
    if (typeof organizationIdOrQuery === "number") {
      return `${configUrl}${path}?organizationId=${organizationIdOrQuery}`;
    }

    if (organizationIdOrQuery) {
      return `${configUrl}${path}?${new URLSearchParams(clearEmptyValues(organizationIdOrQuery)).toString()}`;
    }

    return `${configUrl}${path}`;
  };

export const convertPdfToFile = (attachmentName, attachmentContent): File => {
  let byteCharacters = atob(attachmentContent);

  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });
  const file = new File([blob], attachmentName, { type: "application/pdf" });

  return file;
};

export const ensureArray = (thing: any) => (thing ? (Array.isArray(thing) ? thing : [thing]) : []);

export const getAuthServiceUrl = pathQueryHelper(config.authServiceUrl);
